import React, { Suspense } from 'react';
import CircularProgress from '../../../components_base/CircularProgress';


const SharedShippingDetail = React.lazy(() => import('../components/SharedShippingDetail'));
function SharedShippingDetailView(props: any) {
  return (
    <Suspense fallback={<CircularProgress />}>
      <SharedShippingDetail {...props} />
    </Suspense>
  );
}

export default SharedShippingDetailView;
